import { GoogleMap, Marker } from '@react-google-maps/api';
import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { useMapInfoContext } from 'components/DataMap/MapInfoProvider';

const mapStyles = [
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
];

const baseOptions = {
  clickableIcons: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  draggable: false,
  draggableCursor: 'default',
  gestureHandling: 'none',
  keyboardShortcuts: false,
  scrollwheel: false,
  styles: mapStyles,
  zoomControl: false,
};

const HomeEstimationMap = ({
  center, similarHomes = [], mode = 'subject', className = '',
}) => {
  const { isMapsApiLoaded } = useMapInfoContext();
  const onLoad = React.useCallback((map) => {
    if (mode !== 'comparables' || !similarHomes.length || !window.google) return;
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(center);
    similarHomes.forEach((home) => bounds.extend(home.coordinates));
    map.fitBounds(bounds, 42);
  }, [center, similarHomes, mode]);
  const mapOptions = React.useMemo(() => ({
    ...baseOptions,
    mapTypeId: mode === 'comparables' ? 'roadmap' : 'hybrid',
  }), [mode]);

  if (!isMapsApiLoaded) {
    return (
      <div className={`al-map-skeleton ${className}`} role="status" aria-label="Loading map">
        <Skeleton animation="wave" variant="rect" width="100%" height="100%" />
      </div>
    );
  }
  return (
    <div className={className} style={{ position: 'relative' }}>
      <GoogleMap
        onLoad={onLoad}
        mapContainerStyle={{ width: '100%', height: '100%' }}
        center={center}
        zoom={mode === 'subject' ? 20 : 14}
        options={mapOptions}
      >
        {mode === 'comparables' && (
          <Marker
            clickable={false}
            position={center}
            label={{
              text: 'YOU', color: '#ffffff', fontSize: '10px', fontWeight: '700',
            }}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              fillColor: '#f26430',
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 4,
              scale: 18,
            }}
            zIndex={20}
          />
        )}
        {mode === 'comparables' && similarHomes.map((home, index) => (
          <Marker
            clickable={false}
            key={`${home.propertyAddress}-${index}`}
            position={home.coordinates}
            label={{
              text: String(index + 1), color: '#ffffff', fontSize: '12px', fontWeight: '700',
            }}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE, fillColor: '#102a2b', fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 3, scale: 15,
            }}
          />
        ))}
      </GoogleMap>
      {mode === 'comparables' && (
        <span className="al-map-label">
          {`${similarHomes.length} ${similarHomes.length === 1 ? 'RECENT SALE' : 'RECENT SALES'}`}
          {similarHomes.some((home) => home.distanceMiles !== undefined) && (
            <>
              {` WITHIN ${Math.max(...similarHomes.map((home) => home.distanceMiles || 0)).toFixed(1)} MI`}
            </>
          )}
        </span>
      )}
    </div>
  );
};

export default React.memo(HomeEstimationMap);
